/*! StartNoStringValidationRegion enum values */
export enum LogonProviderType {
  Staff = "Staff",
  Contact = "Contact",
  Person = "Person",
}
/*! EndNoStringValidationRegion */
